import { render } from "./UgmFilters.vue?vue&type=template&id=28674e21&scoped=true"
import script from "./UgmFilters.vue?vue&type=script&lang=js"
export * from "./UgmFilters.vue?vue&type=script&lang=js"

import "./UgmFilters.vue?vue&type=style&index=0&id=28674e21&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28674e21"]])

export default __exports__